/**
 * Created by Qingger Corp.
 * User: yangzihua
 * Date: 2019/6/14
 * Time: 17:48
 * Desc: 云店设置-入驻网点
 */

import { isNumber } from 'lodash';
import { Component, Vue, Watch } from 'vue-property-decorator';
import type { ElTree } from 'element-ui/types/tree';
import NewSelectSite from '../newSelectSIte';
import siteConfig from './siteConfig';
import { IPSService } from '@/services/ipsServices';
import { Functions } from '@/library/utils/functions';


// 子组件
import importBatchSet from '@/views/components/importBatchSet';
import { noop } from '@/util';

@Component({
  components: {},
})
export default class RealSite extends Vue {
  $refs: {
    windowTree: ElTree<any, any>;
  };
  /* 数据 */

  /**
   * 网点列表
   * @type {number}
   */
  public realSiteList: Array<SiteList2> = [];

  /**
   * 页码
   * @type {number}
   */
  public page = 1;

  /**
   * 条数
   * @type {number}
   */
  public pageSize = 20;

  /**
   * 总条数
   * @type {number}
   */
  public totalCount = 0;

  /**
   * 关键字
   * @type {string}
   */
  public keyword = '';

  /**
   * 关键字
   * @type {string}
   */
  public keywords = '';

  // 特定网点的筛选
  public siteCodes = [];

  /**
   * 网点列表弹窗是否显示
   * @type {boolean}
   */
  public isSiteListShow = false;

  public isClose = '';

  public tableSelect = [];

  // 删除标记
  public deleteFlag = false;

  public operationMode: number | string = '';

  public isMoreSite: number | string = '';

  public isShowButton = false;

  // 是否开启分账 0 未开启 1开启
  public isOpenSplit = 0;

  // 分账配置筛选条件 0 关闭 1 开启 9 全部
  public isSplitMoney = '';

  /**
   * 分销配置
   * @type {number | string}
   */
  public policyConfig = '';

  /**
   * 云商城模式下 可选网点
   * @param newVal
   */
  public enableCode = [];

  protected defaultProps: ItemObject = {
    children: 'children',
    label: 'name',
  };

  // 获取列表高度
  get getHeight() {
    let result = this.$store.state.windowHeight - 175;
    this.isShowButton && (result -= 51);
    this.$route.params.mode == '1' && (result -= 56);
    return result;
  }

  /* 方法 */

  /**
   * 关键字搜索
   * @return null
   */
  public onSearchRealSite() {
    this.page = 1;
    this.pageSize = 20;
    this.getSiteList();
  }

  /**
   * 条数变更
   * @param {number} val
   * @return null
   */
  public onSizeChange(val: number): void {
    this.page = 1;
    this.pageSize = val;
    this.getSiteList();
  }

  /**
   * 页码变更
   * @param {number} val
   * @return null
   */
  public onPageChange(val: number): void {
    this.page = val;
    this.getSiteList();
  }

    // 选择网点
    openSelectSiteDialog() {
      new NewSelectSite().open({
        service: 'authTree',
        selectCodes: this.siteCodes,
        readonly: false,
      }).then((val: string[]) => {
        this.siteCodes = val;
        this.getSiteList()
      }, noop);
    }
  /**
   * 获取网点列表
   * @return null
   */
  public getSiteList(): void {
    const loading = this.$loading({
      lock: true,
      text: '请稍等...',
      spinner: 'el-icon-loading',
      background: 'rgba(225,225,225,0.3)',
    });
    const postParams = {
      sgId: +this.$route.params.id,
      page: this.page,
      isAll: 1,
      siteCodes: this.siteCodes,
      pageNum: this.pageSize,
      keywords: this.keywords,
      isClose: isNumber(this.isClose) ? this.isClose : 9,
      isSplitMoney: isNumber(this.isSplitMoney) ? this.isSplitMoney : 9,
      policyConfig: isNumber(this.policyConfig) ? this.policyConfig : 9,
    };
    // 波老师说这个接口即将被删除
    // IPSService.realSiteList({ postParams }).then(
    IPSService.realSiteGroupSiteList({ postParams }).then(
      (res) => {
        this.isOpenSplit = res.isOpenSplit;
        // 格式化数据
        if (res.list.length > 0) {
          res.list.forEach((item) => {
            item.siteTel = Functions.emptyVaribleHandler(item.siteTel);
            item.siteAddress = Functions.emptyVaribleHandler(item.siteAddress);
          });
        }

        this.realSiteList = res.list;
        this.isShowButton = this.$route.params.mode == '1' || (this.$route.params.mode == '2' && this.realSiteList.length == 0) || (this.$route.params.mode == '3' && this.realSiteList.length == 0);
        this.deleteFlag = false;
        this.totalCount = res.count;
        loading.close();
      },
      () => {
        loading.close();
      },
    );
  }

  /**
   * 删除小程序
   * @param {number} id
   * @return null
   */
  public onDeleteSite(id: number[]): void {
    this.$confirm('是否删除此网点?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      closeOnClickModal: false,
      type: 'warning',
    }).then(() => {
      const postParams = {
        sgmIds: id,
      };
      IPSService.removeSiteGroupInfoNode({ postParams }).then((res) => {
        if (res.ret) { this.$message.success('删除成功'); }
        this.page = 1;
        this.pageSize = 20;
        this.siteCodes = [];
        this.deleteFlag = true;
        this.getSiteList();
      });
    });
  }

  handleBatch(state) {
    if (!this.tableSelect.length) {
      return false;
    }
    const sgmId = this.tableSelect.map(i => i.sgmId);
    const siteId = this.tableSelect.map(i => i.siteId);
    switch (state) {
      case 'delete':
        this.deleteFlag = true;
        this.onDeleteSite(sgmId);
        break;
      case 'allow':
        this.changeSaleState(siteId, 1);
        break;
      case 'prohibit':
        this.changeSaleState(siteId, 0);
        break;
    }
  }

  handleTableSelect(select) {
    this.tableSelect = select;
  }

  handleIsCloseChange() {
    this.getSiteList();
  }

  handleIsSplitMoneyChange() {
    this.getSiteList();
  }

  /**
   * 更新销售状态
   * @param {number} id
   * @param state
   * @return null
   */
  public changeSaleState(id: number | number[], state: number): void {
    this.$confirm(`是否${state === 0 ? '允许' : '禁止'}此网点销售商品?`, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      closeOnClickModal: false,
      type: 'warning',
    }).then(() => {
      const postParams = {
        siteIds: Array.isArray(id) ? id : [id],
      };
      (state === 0 ? IPSService.adminSiteOpen : IPSService.adminSiteClose)({ postParams }).then((res: any) => {
        if (res.result) {
          this.$message.success('更新状态成功');
          this.page = 1;
          this.pageSize = 20;
          this.getSiteList();
        }
      });
    }, noop);
  }


  /**
   * 网点弹窗隐藏
   * @return null
   */
  public onSelectSiteHide(): void {
    this.isSiteListShow = false;
  }

  /**
   * 节点点击时调用
   * @return null
   */
  // public onClickNode(item) {
  //   this.page = 1;
  //   this.pageSize = 20;
  //   this.siteCodes = this.getTreeAllSite(item).map(i => i.code);
  //   this.getSiteList();
  // }

  getTreeAllSite(data) {
    const childSite = [];
    const deepSearch = (node) => {
      if (node.isSite) {
        childSite.push(node);
        return;
      } else if (Array.isArray(node.children) && node.children.length) {
        node.children.forEach((i) => {
          deepSearch(i);
        });
      }
    };
    deepSearch(data);
    return childSite;
  }

  setSelectState = (data, b?) => {
    if (data.children) {
      data.childLen = this.getTreeAllSite(data).length;
      data.children = data.children.map((i) => {
        return this.setSelectState(i, b);
      });
      return data;
    } else if (data.isSite) {
      return data;
    }
  };

  setTreeSiteState(treeData, b?) {
    if (treeData && Array.isArray(treeData)) {
      return treeData.map((i) => {
        return this.setSelectState(i, b);
      });
    } else {
      return [];
    }
  }

  /**
   * 分账配置
   */
  public splitConfig(siteCode) {
    siteConfig.open({ siteCode, isOpenSplit: this.isOpenSplit }).then((result) => {
      result && this.getSiteList();
    }, noop);
  }

  public batchSet() {
    importBatchSet
      .open({
        title: '批量配置',
        fromKey: 'site',
        postParams: { sgId: +this.$route.params.id },
        empCode: this.$store.state.empCode,
        importUrl: 'nips/admin/split/money/template/import',
      })
      .then((result) => {
        if (result.flag) {
          this.getSiteList();
        }
      }, noop);
  }

  // 选择分销网点
  async selectDistributionSite() {

		new NewSelectSite().open({
			isOutAuth: 1,
			showAllSite: 1,
      sgId: +this.$route.params.id,
    }).then((result) => {
      IPSService.adminSiteGroupSiteAdd({
        postParams: {
          siteCodes: result,
          sgId: +this.$route.params.id,
        },
      }).then((response) => {
        this.$message.success('添加成功');
        this.getSiteList();
      });
    }, noop);
  }

  /**
   * 参与分销表头
   */
  renderHeader(h, { column }) {
    const contentTip = '设置参与分销网点的目的是对在实体门店中入职的导购进行识别，只有该导购所在实体网点作为分销网点配置到当前【云商城网点】中，该导购方可进入该网点并成为导购分销员。';
    return h('span', {}, [
      h('span', {}, column.label),
      h(
        'el-tooltip',
        {
          attrs: {
            class: 'iconfont iconzhushi1 font-size-18 r-ml-8 text-blue-15 relative-position',
            style: 'top: 1px',
            effect: 'light',
            content: contentTip,
            placement: 'top',
          },
        },
        [h('i', {})],
      ),
    ]);
  }

  /**
   * 获取云商城模式下 已选网点
   */
  public getSelectedSite(vSiteId) {
    return IPSService.cloudDistributionSiteGet({
      postParams: {
        vSiteId,
        keyword: '',
      },
    }).then((response) => {
      return {
        selectedIds: (response.list || []).map(v => v.siteId),
        selectCodes: (response.list || []).map(v => v.siteCode),
      };
    });
  }

  /**
   * 获取云商城模式下 可选网点
   */
  public getEnableSite(siteId) {
    return IPSService.cloudDistributionSiteList({
      postParams: {
        siteId,
        keyword: '',
      },
    }).then((response) => {
      return {
        enableIds: (response.list || []).map(v => v.siteId),
        enableCodes: (response.list || []).map(v => v.siteCode),
      };
    });
  }

  /**
   * 临时方案先调一边接口拿到树结构
   * 获取第一个节点下的code再去获取网点列表
   */
  // getFirstNodeCodes() {
  //   const loading = this.$loading({
  //     lock: true,
  //     text: '请稍等...',
  //     spinner: 'el-icon-loading',
  //     background: 'rgba(225,225,225,0.3)',
  //   });
  //   const postParams = {
  //     sgId: +this.$route.params.id,
  //     page: this.page,
  //     isAll: 1,
  //     siteCodes: this.siteCodes,
  //     pageNum: this.pageSize,
  //     keywords: this.keywords,
  //     isClose: isNumber(this.isClose) ? this.isClose : 9,
  //     isSplitMoney: isNumber(this.isSplitMoney) ? this.isSplitMoney : 9,
  //     policyConfig: isNumber(this.policyConfig) ? this.policyConfig : 9,
  //   };
  //   return IPSService.realSiteList({ postParams }).then((response) => {
  //     return this.setTreeSiteState(response.treeList)[0] || {};
  //   });
  // }

  /* 周期 */

  /**
   * 当组建创建时
   */
  public async created() {
    // this.createConnect();
    // const firstNode = await this.getFirstNodeCodes();
    // this.siteCodes = this.getTreeAllSite(firstNode).map(i => i.code);
    this.getSiteList(); // 获取网点列表
    this.operationMode = +this.$route.params.mode;
    this.isMoreSite = +this.$route.params.isMoreSite;
  }
}
